unit ResultSetResponseType;

interface

type
  TResultSetResponseType = class
  private
    fResultSetKey: String;
    fCount: Integer;
    fPageLength: Word;
    fPage: Word;
  public
    property ResultSetKey: String read fResultSetKey;
    property Count: Integer read fCount;
    property PageLength: Word read fPagelength;
    property Page: Word read fPage;
  end;

implementation

end.
